module.exports = __webpack_public_path__ + "img/patch-plus.c3b78775.svg";